import { PAGE_COLOR_PALETTES } from "./constants";

function getUserPalettes() {
    if (typeof localStorage === "undefined") {
        return {};
    }
    const raw = localStorage.getItem("PAGE_COLOR_PALETTES");
    try {
        return JSON.parse(raw);
    } catch (e) {
        localStorage.removeItem("PAGE_COLOR_PALETTES");
        return {};
    }
}

function saveUserPalettes(palettes) {
    if (typeof localStorage === "undefined") {
        return;
    }
    const data = { ...palettes };
    for (const builtin of Object.keys(PAGE_COLOR_PALETTES)) {
        delete data[builtin];
    }
    const raw = JSON.stringify(data);
    localStorage.setItem("PAGE_COLOR_PALETTES", raw);
}

export function isSystemPalette(paletteName) {
    return paletteName in PAGE_COLOR_PALETTES;
}

function getPalettes() {
    return {
        ...getUserPalettes(),
        ...PAGE_COLOR_PALETTES
    };
}

const INITIAL_STATE = {
    palette: "default",
    palettes: getPalettes(),
    paletteModified: false,
    pageColors: PAGE_COLOR_PALETTES.default
};

const SET_PAGE_COLOR_AT_INDEX = "SET_PAGE_COLOR_AT_INDEX";

export function setPageColorAtIndex(index, color) {
    return {
        type: SET_PAGE_COLOR_AT_INDEX,
        payload: {
            index,
            color
        }
    };
}

const SET_PAGE_COLOR_PALETTE = "SET_PAGE_COLOR_PALETTE";

export function setPageColorPalette(palette) {
    return {
        type: SET_PAGE_COLOR_PALETTE,
        payload: {
            palette
        }
    };
}

const SAVE_PAGE_COLORS_AS_PALETTE = "SAVE_PAGE_COLORS_AS_PALETTE";

export function savePageColorsAsPalette(paletteName) {
    return {
        type: SAVE_PAGE_COLORS_AS_PALETTE,
        payload: {
            paletteName
        }
    };
}

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_PAGE_COLOR_AT_INDEX:
            const { index, color } = action.payload;
            if (state.pageColors[index] === color) {
                return state;
            }

            const pageColors = [...state.pageColors];
            pageColors[index] = color;

            return {
                ...state,
                paletteModified: true,
                pageColors
            };

        case SET_PAGE_COLOR_PALETTE:
            const { palette } = action.payload;
            const colors = state.palettes[palette];
            if (!colors) {
                return state;
            }
            return {
                ...state,
                palette,
                paletteModified: false,
                pageColors: colors
            };

        case SAVE_PAGE_COLORS_AS_PALETTE:
            const { paletteName } = action.payload;

            const palettes = { ...state.palettes };
            palettes[paletteName] = state.pageColors;
            saveUserPalettes(palettes);

            return {
                ...state,
                palette: paletteName,
                palettes: getPalettes(),
                paletteModified: false
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/pages/reducer.js